module.exports = __webpack_public_path__ + "static/img/hogares-sostenibles.0a04051e.png";